export default "__VITE_ASSET__CTFvSDec__"